// extracted by mini-css-extract-plugin
export default {"footerContainer":"Videos_footerContainer__kQdTv"};